import React, { useState } from 'react';
import { PURPLE } from '../utils/designUtils';

export default function DeleteOrganizationConfirmModal({ isOpen, onClose, onConfirm, organizationCode }) {
    const [agree1, setAgree1] = useState(false);
    const [agree2, setAgree2] = useState(false);

    const handleConfirm = () => {
        onConfirm(agree1 && agree2);
        onClose();
    };

    if (!isOpen) return null;

    const labelStyle = { display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 14, color: '#3a3849', cursor: 'pointer', lineHeight: 1.5 };

    return (
        <div onClick={onClose} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div onClick={(e) => e.stopPropagation()} style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 480, boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
                <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0eff5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 700, fontSize: 15, color: '#1f1d2e' }}>조직 삭제 확인</span>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#8b8a99', lineHeight: 1 }}>×</button>
                </div>
                <div style={{ padding: '20px' }}>
                    <p style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 600, color: '#1f1d2e' }}>기업에 속한 개인 사용자가 있습니다.</p>
                    <p style={{ margin: '0 0 20px', fontSize: 15, fontWeight: 600, color: '#1f1d2e' }}>사용자 모두 일괄 삭제 하시겠습니까?</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <label style={labelStyle}>
                            <input type="checkbox" checked={agree1} onChange={(e) => setAgree1(e.target.checked)} style={{ accentColor: PURPLE, cursor: 'pointer', flexShrink: 0, marginTop: 2 }}/>
                            사용자의 모든 정보가 삭제되며, 복구할 수 없습니다.
                        </label>
                        <label style={labelStyle}>
                            <input type="checkbox" checked={agree2} onChange={(e) => setAgree2(e.target.checked)} style={{ accentColor: PURPLE, cursor: 'pointer', flexShrink: 0, marginTop: 2 }}/>
                            사용자 일괄 삭제에 대한 책임은 각 기업에 있습니다.
                        </label>
                    </div>
                </div>
                <div style={{ padding: '12px 20px', borderTop: '1px solid #f0eff5', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <button onClick={onClose} style={{ height: 36, padding: '0 16px', borderRadius: 8, border: '1.5px solid #d1d5db', background: 'white', color: '#6b7280', fontWeight: 600, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}>아니오</button>
                    <button onClick={handleConfirm} disabled={!(agree1 && agree2)} style={{ height: 36, padding: '0 16px', borderRadius: 8, border: 'none', background: !(agree1 && agree2) ? '#fca5a5' : '#ef4444', color: 'white', fontWeight: 600, fontSize: 14, cursor: !(agree1 && agree2) ? 'default' : 'pointer', fontFamily: 'inherit' }}>예</button>
                </div>
            </div>
        </div>
    );
}
